<script lang="ts" module>
  import { tv } from '@/ui/tv';
  import { useTeoCore } from '@/utils/teo-context/teoAtom';

  export interface VersionScoreProps {
    value: number;
    class?: string;
  }

  const styles = tv({
    base: 'min-w-20 rounded-sm p-1 text-center text-md font-semibold text-c-base',
    variants: {
      status: {
        good: 'bg-success',
        warn: 'bg-warning',
        bad: 'bg-error',
      },
    },
  });
</script>

<script lang="ts">
  let { value, class: className }: VersionScoreProps = $props();
  let cn = $derived(getClass(value, className));
  const core = useTeoCore();

  function getStatus(value: number) {
    if (value >= core.staticConfig.tpiTarget) return 'good';
    if (value > 50) return 'warn';
    return 'bad';
  }

  function getClass(value: number, className?: string) {
    return styles({ status: getStatus(value), className });
  }
</script>

<span class={cn}>TPI: {Math.floor(value)}%</span>
